
//动态墙体材质
function StandardWallMaterialProperty(options) {
    this._definitionChanged = new Cesium.Event();
    this._color = undefined; //颜色
    this._colorSubscription = undefined;
    this._time = (new Date()).getTime();

    this.color = options.color;
    this.duration = options.duration; //速度
    this.image = options.image;//自定义图片
    this.count = options.count;//自定义图片
}
Object.defineProperties(StandardWallMaterialProperty.prototype, {
    isConstant: {
        get: function () {
            return false;
        }
    },
    definitionChanged: {
        get: function () {
            return this._definitionChanged;
        }
    },
    color: Cesium.createPropertyDescriptor('color')
});
StandardWallMaterialProperty.prototype.getType = function (time) {
    return Cesium.Material.StandardWallMaterialType;
}
StandardWallMaterialProperty.prototype.getValue = function (time, result) {
    if (!Cesium.defined(result)) {
        result = {};
    }
    result.color = Cesium.Property.getValueOrDefault(this._color, time, Cesium.Color.RED, result.color);
    result.count = this.count;
    result.image = Cesium.Material.DefaultImageStandardWallMaterialType;
    result.time = (((new Date()).getTime() - this._time) % this.duration) / this.duration;
    return result;
}

StandardWallMaterialProperty.prototype.equals = function (other) {
    return this === other ||
        (other instanceof StandardWallMaterialProperty &&
            Cesium.Property.equals(this._color, other._color))
}


export default StandardWallMaterialProperty;